// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nfieidoznythpmocbxia.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5maWVpZG96bnl0aHBtb2NieGlhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI2NzcxNTIsImV4cCI6MjA2ODI1MzE1Mn0.c9himEnqF4e7VTR_CWAX1pcjldQvdEHQA9aIkQAapQ4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);